<div>
    <div class="wizard-header row">
        <div class="col-12 page-title">
            {{'specialOffers.title' | translate}}
        </div>
    </div>

    <div class="wizard-container">
        <button
            class="btn link-btn btn-back-txt"
            (click)="redirectToPrevStep()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{("specialOffers.wizard.previousStep" | translate)}}
            </span>
        </button>
        <div class="wizard-main-content">
            <form #form="ngForm">
                <ng-container class="wizard-item">
                    <div class="row">
                        <div class="col-12 wizard-question">
                            {{ "specialOffers.wizard.financingDetails.title" | translate }}
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{'specialOffers.wizard.financingDetails.minDownPayment' | translate}}
                                    ({{specialOffer.currencyCode}})
                                </label>
                                <div>
                                    <kendo-numerictextbox
                                        HJSuppress
                                        class="l-numeric-textbox-container"
                                        [spinners]="false"
                                        [min]="0"
                                        [(ngModel)]="specialOffer.minimumDownPayment"
                                        placeholder="{{'specialOffers.wizard.financingDetails.placeholder.typeMinDownPayment' | translate}}"
                                        name="minimumDownPayment">
                                    </kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ 'specialOffers.wizard.financingDetails.interest' | translate }}
                                </label>
                                <div>
                                    <kendo-numerictextbox
                                        HJSuppress
                                        class=" l-numeric-textbox-container"
                                        format="n2"
                                        [min]="0"
                                        [max]="100"
                                        [(ngModel)]="specialOffer.interest"
                                        [spinners]="false"
                                        placeholder="{{ 'specialOffers.wizard.financingDetails.placeholder.typeInterestRate' | translate }}"
                                        name="interest"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit">
                                    </kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.financingDetails.financingPeriod" | translate }}
                                </label>
                                <div class="input-dropdown-container">
                                    <kendo-combobox
                                        HJSuppress
                                        class="custom-kendo-control-xl"
                                        [size]="sizeLarge"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        name="financingPeriod"
                                        [placeholder]="'specialOffers.wizard.financingDetails.placeholder.selectFinancingPeriod' | translate"
                                        [clearButton]="false"
                                        [data]="financingPeriods"
                                        [valueField]="'id'"
                                        [textField]="'value'"
                                        [valuePrimitive]="true"
                                        [(ngModel)]="specialOffer.financingPeriod"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        #financingPeriod
                                        (click)="!financingPeriod.isOpen && !financingPeriod.disabled ?
                                        financingPeriod.toggle() : null">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ 'specialOffers.wizard.financingDetails.estimatedMonthlyInstallment' | translate}}
                                    ({{specialOffer.currencyCode}})
                                </label>
                                <div>
                                    <kendo-numerictextbox
                                        HJSuppress
                                        class=" l-numeric-textbox-container"
                                        [min]="0"
                                        [(ngModel)]="specialOffer.estMonthlyInstallment"
                                        [spinners]="false"
                                        placeholder="{{ 'specialOffers.wizard.financingDetails.placeholder.typeEstimatedMonthlyInstallment' | translate }}"
                                        name="estMonthlyInstallment"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit"
                                    >
                                    </kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div
                                class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex"
                                [innerHTML]="'common.requiredFields' | translate">
                            </div>
                        </div>
                        <div class="col-12 action">
                            <div class="d-flex justify-content-center mt-5">
                                <button
                                    class="btn primary-btn"
                                    [disabled]="(!specialOffer.minimumDownPayment || !specialOffer.interest || !specialOffer.financingPeriod || !specialOffer.estMonthlyInstallment)"
                                    (click)="nextStepHandler()">
                                    {{ "specialOffers.wizard.nextBtn" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>